import React from "react";
import PropTypes from "prop-types";
import GutenbergBlock from "./gutenberg-block";
import SwipeContainer from "./swipecontainer";

const GutenbergBlocks = ({ blocks, seo }) => {
  /* Group similar blocks together */
  const chunks =
    blocks?.reduce((chunks, block) => {
      const lastChunk = chunks.slice(-1)?.[0];
      if (block.name === lastChunk?.wrapper) {
        lastChunk.blocks.push(block);
        return chunks;
      } else {
        return [
          ...chunks,
          {
            wrapper: block.name,
            blocks: [block],
          },
        ];
      }
    }, []) || [];

  return (
    <>
      {chunks.map(({ wrapper, blocks }, i) => {
        switch (wrapper) {
          case "mev/card":
            return (
              <div
                key={i}
                className="row-container"
                style={{ justifyContent: "flex-start" }}
              >
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </div>
            );

          case "mev/handpicked-product-category":
            return (
              <div
                key={i}
                className="row-container"
                style={{ justifyContent: "flex-start" }}
              >
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </div>
            );
          case "mev/faq":
            return (
              <div
                key={i}
                className="faq-container"
                style={{ justifyContent: "flex-start" }}
              >
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </div>
            );
          case "mev/info-card":
            return (
              <SwipeContainer key={i}>
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </SwipeContainer>
            );
          case "mev/metric":
            return (
              <div
                key={i}
                className="row-container metric-wrapper"
                style={{ margin: 0, justifyContent: "center" }}
              >
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </div>
            );
          case "mev/video-card":
            return (
              <div key={i} className="row-container">
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </div>
            );
          default:
            return (
              <React.Fragment key={i}>
                {blocks.map((block, j) => (
                  <GutenbergBlock key={j} block={block} seo={seo} />
                ))}
              </React.Fragment>
            );
        }
      })}
    </>
  );
};

export default GutenbergBlocks;

GutenbergBlocks.propTypes = {
  blocks: PropTypes.array,
  seo: PropTypes.array,
};
